import { render, staticRenderFns } from "./empty-index.vue?vue&type=template&id=1b9ec823&"
import script from "./empty-index.vue?vue&type=script&lang=js&"
export * from "./empty-index.vue?vue&type=script&lang=js&"
import style0 from "./empty-index.vue?vue&type=style&index=0&id=1b9ec823&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../resource-manage/node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports